<template>
  <div class="honor">
	  <Bannerinner/>
	<div class="content">
		<div class="titleinfo">
			<h3><a href="/">首页</a><em>></em><router-link :to="{path:'/honor/index.html'}">冠领荣誉</router-link></a><em>></em>{{lmname}}</h3>
			<h2 class="linebox">
				<strong>冠领荣誉</strong>
				<em></em>
				<p>风雨历程&nbsp;&nbsp;&nbsp;&nbsp;鼎信天下</p>
			</h2>
		</div>
		
		<div class="contbox">
			<div class="comtbtn">
				<strong @click="changeIndex(index,item.xid,item.zmid)" v-for="item,index in navList" :key="item.id" :class="index == currentIndex ? 'active' : ''">{{item.name}}</strong>
			</div>
			<div class="honorwrap">
				<div class="honorbox" v-show="currentIndex == 0">
					<ul>
						<li v-for="item,index in databox" :key="item.id"><router-link :to="{path: '/honor/'+item.type+'/'+item.id+'.html'}"><img :src="item.thumb" alt=""><p>{{item.title}}</p></router-link></li>
					<!-- hide-on-single-page -->
					</ul>
					<div class="page">
					 <el-pagination
					   background
					   current-page.sync=''
					   @current-change="getPage"
					   layout="prev, pager, next"
					   prev-text="上一页"
					   next-text="下一页"
					   :pager-count = pagerCount
					   :total="total">
					 </el-pagination>
					</div>
				</div>
				<div class="honorbox" v-show="currentIndex == 1">
					<ul>
						<li v-for="item,index in databox" :key="item.id"><router-link :to="{path: '/honor/'+item.type+'/'+item.id+'.html'}"><img :src="item.thumb" alt=""><p>{{item.title}}</p></router-link></li>
					<!-- hide-on-single-page -->
					</ul>
					<div class="page">
					 <el-pagination
					   background
					   current-page.sync=''
					   @current-change="getPage"
					   layout="prev, pager, next"
					   prev-text="上一页"
					   next-text="下一页"
					   :pager-count = pagerCount
					   :total="total">
					 </el-pagination>
					</div>
				</div>
				<div class="honorbox" v-show="currentIndex == 2">
					<ul>
						<li v-for="item,index in databox" :key="item.id"><router-link :to="{path: '/honor/'+item.type+'/'+item.id+'.html'}"><img :src="item.thumb" alt=""><p>{{item.title}}</p></router-link></li>
					<!-- hide-on-single-page -->
					</ul>
					<div class="page">
					 <el-pagination
					   background
					   hide-on-single-page
					   current-page.sync=''
					   @current-change="getPage"
					   layout="prev, pager, next"
					   prev-text="上一页"
					   next-text="下一页"
					   :pager-count = pagerCount
					   :total="total">
					 </el-pagination>
					</div>
				</div>
			</div>



		</div>

	</div>
  </div>
</template>

<script>
import $ from 'jquery'
import {request} from '../network/request.js'
import GLOBAL from '../global/global.js'
import Bannerinner from "@/components/Bannerinner"
import { title } from '../global/common.js'
export default {
	name: 'Honor',
	components:{
		Bannerinner
	},
	data(){
	  return {
		  databox:[],
		  pagerCount:5,
		  total:0,
		  catid: 24,
		  zhixing:0,
		  lmname:'锦旗荣誉',
		  currentIndex:0,
		  xid:0,
		  zmid:0,
		  navList:[
			  {id:0,name:'锦旗荣誉',xid:24,zmid:6},
			  {id:1,name:'奖杯荣誉',xid:25,zmid:7},
			  {id:2,name:'好评荣誉',xid:64,zmid:0},
		  ]
	  }
	},
	methods: {
		getData(){
			let that = this
			request({
				url: '/honor/liebiao?xid='+that.xid+'&zmid='+that.zmid+'&page=1&page_size=9',
				responseType: 'json',
				transformResponse:[function(data){
					let jsondata = JSON.parse(data)
					
					if(jsondata['code'] == 200){
						that.databox = []
						let beforeData = jsondata['data']
						jsondata['data'].forEach(function(value,index,arr){
							if(value['leibie'] == "xinty"){
								value['type'] = 'v'
								if(value['thumb'].length > 100){
									let beforeimg = value['thumb'].split(':')[21];
									value['thumb'] = GLOBAL.httpurl+beforeimg.substr(1,beforeimg.length-4)
								}
							}else if(value['leibie'] == 'zmty'){
								value['type'] = 'm'
								value['thumb'] = 'http://api.guanlingls.com'+value['thumb']
							}
							value['create_time'] = value['create_time'].split(' ')[0]
							that.databox.push(value)
							
						})
						that.total = jsondata['data'][0]['total']	//总页数
						// console.log(that.anliData)
					}
				}]
			})
		},
		getPage(val){
			let that = this
			request({
				url: '/honor/liebiao?xid='+that.xid+'&zmid='+that.zmid+'&page='+val+'&page_size=9',
				responseType: 'json',
				transformResponse:[function(data){
					let jsondata = JSON.parse(data)
					
					if(jsondata['code'] == 200){
						that.databox = []
						let beforeData = jsondata['data']
						jsondata['data'].forEach(function(value,index,arr){
							if(value['leibie'] == "xinty"){
								value['type'] = 'v'
								if(value['thumb'].length > 100){
									let beforeimg = value['thumb'].split(':')[21];
									value['thumb'] = GLOBAL.httpurl+beforeimg.substr(1,beforeimg.length-4)
								}
							}else if(value['leibie'] == 'zmty'){
								value['type'] = 'm'
								value['thumb'] = 'http://api.guanlingls.com'+value['thumb']
							}
							value['create_time'] = value['create_time'].split(' ')[0]
							that.databox.push(value)
							
						})
						that.total = jsondata['data'][0]['total']	//总页数
						// console.log(that.anliData)
					}
				}]
			})
		},
		getlmName(catid){
			let that = this
			request({
				url: '/Category/read?id='+catid,
				responseType: 'json',
				transformResponse:[function(data){
					let jsondata = JSON.parse(data)
					// console.log(jsondata);
					if(jsondata['code'] == 200){
						that.lmname = jsondata['data']['name']
						document.title = jsondata['data']['name'] + '-' + title
					}
				}]
			})
		},
		changeIndex(index,xid,zmid){
			this.lmname = this.navList[index].name
			this.currentIndex = index
			this.xid = xid
			this.zmid = zmid
			this.getData()
		},
		initData(){
			this.xid = 24
			this.zmid = 6
			this.getData()
			document.title = '冠领荣誉-'+title
		}
	},
	created() {
		this.initData()
		

		
	},
	watch:{
		$route(to,from){
			this.initData()
		}
	}
}
</script>

<style lang="scss" scoped>

	
	.myform{
	    border-top: none !important;
	}
	.content{
	
	    .contbox{
	        padding-top: .2rem;
	        padding-bottom: .2rem;
	        background: #fff;
	        margin-top: .22rem;
	        .comtbtn{
	            display: flex;
	            justify-content: center;
	            margin-top: .25rem;
	            padding-bottom: .5rem;
	            // border-bottom: 1px solid #eee;
	            strong{
	                width: 2.1rem;
	                border: 1px solid #eeeeee;
	                text-align: center;
	                height: .6rem;
	                line-height: .6rem;
	                margin: 0 .1rem;
	                font-size: .28rem;
	                color: #9b9494;
	            }
	            strong.active{
	                background: #cc0e0e;
	                color: #fff;
	            }
	        }
	        .honorwrap{
	            .honorbox{
	                ul{
	                    display: flex;
	                    flex-wrap: wrap;
	                    padding: 0 .2rem;
	                    li{
	                        width: 2.1rem;
	                        margin-bottom: .3rem;
	                        a{
	                            img{
	                                border-radius: .2rem;
	                                width: 2.1rem;
	                                height: 3.2rem;
	                            }
	                            p{
	                                font-size: .26rem;
	                                color: #9b9494;
	                                text-align: center;
	                                margin-top: .08rem;
									text-overflow: ellipsis;
									display: -webkit-box;
									-webkit-box-orient: vertical;
									-webkit-line-clamp: 2;
									overflow: hidden;
	                            }
	                        }
	                    }
	                    li:nth-child(3n+2){
	                        margin: 0 .4rem;
	                    }
	                }
	            }
	            .honorbox:nth-child(2){
	                ul{
	                    li{
	
	                        img{
	                            height: 1.72rem;
	                        }
	                    }
	                }
	            }
	            .honorbox:nth-child(3){
	                ul{
	                    li{
	                        
	                        img{
	                            height: 3.2rem;
	                            box-shadow: 0 0 .05rem #ccc;
	                            border-radius: .05rem;
	                        }
	                        p{
	                            white-space: nowrap;
	                            overflow: hidden;
	                            text-overflow: ellipsis;
	                        }
	                    }
	                }
	            }
	        }
	
	
	    }
	}

</style>
